import * as planningApi from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import { handleError } from "app/redux/errorHandler/errorHandler.saga"
import WorkingHour from "app/models/workingHour"
import * as actions from "./preferedHours.actions"
import * as notificationActions from "../notifications/notifications.actions"

export function* getPreferedHoursFlow(action: actions.GetPreferedHoursAction): SagaIterator {
  try {
    const response = yield call(planningApi.getTimetables, action.payload.id)
    yield put(actions.getPreferedHoursSuccess(response && response.data))
  } catch (e) {
    yield put(actions.getPreferedHoursFail(e))
    yield call(handleError, { error: e })
  }
}

export function* putPreferedHoursFlow({ payload }: actions.PutPreferedHoursAction): SagaIterator {
  try {
    const response = yield call(planningApi.putTimetablesById, payload)
    yield put(actions.putPreferedHoursSuccess(response.data))
    yield put(
      notificationActions.show({
        id: "putPreferedHoursSuccess",
        message: "notifications.preferedhours.put.success",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.putPreferedHoursFail(e))
    yield call(handleError, { error: e })
  }
}

export function* deletePreferedHoursFlow({ payload }: actions.DeletePreferedHoursAction): SagaIterator {
  try {
    const { id: userId, data } = payload
    let deletedItems: WorkingHour[] = []
    for (const workingHour of data) {
      const deletedItemResult = yield call(planningApi.deleteTimetablesById, userId, workingHour)
      deletedItems = [...deletedItems, deletedItemResult.data]
    }
    yield put(actions.deletePreferedHoursSuccess(deletedItems))
  } catch (e) {
    yield put(actions.deletePreferedHoursFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* preferedHoursSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getPreferedHoursFlow)
  yield takeLatest(actions.Types.PUT, putPreferedHoursFlow)
  yield takeLatest(actions.Types.DELETE, deletePreferedHoursFlow)
}
